import React from "react";

export default function Christmas1({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-chr11{fill:#ba3131}.cls-chr12{fill:#c95353}.cls-chr13{fill:#a82626}.cls-chr15{fill:#ff791f}.cls-chr16{fill:#b24444}.cls-chr17{fill:#991a1a}.cls-chr19{fill:#f9a15f}.cls-chr110{fill:#ffa364}.cls-chr111{fill:#d45d47}.cls-chr112{fill:#ffb583}.cls-chr113{fill:#ffcf94}.cls-chr114{fill:#e97357}.cls-chr115{opacity:.6}.cls-chr116{fill:#a0531a}.cls-chr117{fill:#e58b41}"
            }
          </style>
        </defs>
        <path
          d="M1479.52 1702.46H482.45c-83.72 0-151.83-68.11-151.83-151.83V214.51c0-83.72 68.11-151.83 151.83-151.83h997.07c83.72 0 151.83 68.11 151.83 151.83v1336.13c0 83.72-68.11 151.83-151.83 151.83ZM482.45 94.35c-66.26 0-120.16 53.9-120.16 120.16v1336.13c0 66.26 53.9 120.16 120.16 120.16h997.07c66.26 0 120.16-53.9 120.16-120.16V214.51c0-66.26-53.9-120.16-120.16-120.16H482.45ZM893.17 1759.8c-34.75 9.11-116.47 35.91-175.46 113.4-19.75 25.94-32.53 51.75-40.95 73.71 5.23-3.91 11.04-7.88 17.45-11.75 13.24-8.01 25.9-13.7 37.03-17.8-1.29 6.83-2.33 15.83-1.78 26.35.59 11.3 2.84 20.71 5.04 27.63 35.55-40.8 82.95-86.94 144.52-129.83a783.402 783.402 0 0 1 75.14-46.29c-20.33-11.8-40.66-23.61-60.98-35.41Z"
          className="cls-chr13"
        />
        <path
          d="M676.76 1946.91c8.43-21.96 21.2-47.77 40.95-73.71 58.99-77.48 140.71-104.29 175.46-113.4 20.33 11.8 40.66 23.61 60.98 35.41a786.595 786.595 0 0 0-54.54 32.43c-16.02-4.12-55.61-11.98-101.2 3.89-61.57 21.44-90.13 70.86-96.86 83.33a147.01 147.01 0 0 1 16.13-8.33c13.51-5.94 26.06-9.03 36.33-10.66-4.73 8.59-12.7 26.3-9.5 47.72.71 4.77 1.89 9.08 3.25 12.88-4.6 5.02-9.03 9.99-13.29 14.87-2.2-6.92-4.44-16.33-5.04-27.63-.55-10.52.49-19.52 1.78-26.35-11.13 4.1-23.79 9.8-37.03 17.8-6.41 3.87-12.22 7.84-17.45 11.75Z"
          className="cls-chr17"
        />
        <path
          d="M1089.54 1290.02c-3.64.53-15.19 1.71-23.71-5.96-.22-.2-4.32-3.96-6.52-9.6-8.5-21.72 21.41-44.74 19.19-74.98-.6-8.17-3.74-19.46-15.27-32.44 9.6 3.71 25.69 11.56 39.04 27.97 21.61 26.56 32.99 71.82 15.3 88.61-3.25 3.08-10.94 8.47-28.03 6.39Z"
          className="cls-chr110"
        />
        <path
          d="M1090.28 1290.68c-3.18.52-13.27 1.69-20.72-5.87-.19-.2-3.77-3.9-5.7-9.45-7.43-21.38 18.71-44.04 16.77-73.81-.52-8.05-3.27-19.16-13.35-31.93 8.39 3.66 22.45 11.38 34.12 27.54 18.88 26.15 28.83 70.7 13.38 87.23-2.84 3.04-9.56 8.34-24.5 6.29Z"
          className="cls-chr15"
        />
        <path
          d="M1090.97 1287.29c-2.04.23-7.48.5-12.54-3.55-2.7-2.16-4.54-4.95-5.44-6.95-4.88-10.77 5.79-24.19 10.66-44.45 1.83-7.61 3.6-19.34 1.88-35.15 2.75 2.35 7.59 6.88 12.25 13.9 15.15 22.83 21.61 61.9 8.03 72.39-2.5 1.93-6.91 4.15-14.83 3.81Z"
          className="cls-chr110"
        />
        <g className="cls-chr115">
          <path
            d="M1090.24 1287.35c-1.39.23-5.81.74-9.06-2.57-.09-.09-1.65-1.71-2.49-4.13-2.69-7.68 4.04-16.83 8.1-29.72 1.54-4.87 3.21-11.94 3.6-21.2 2.09 2.96 4.97 7.5 7.52 13.58 4.61 10.96 10.85 33.27 3.05 41.29-1.39 1.43-4.39 3.61-10.72 2.75Z"
            className="cls-chr113"
          />
        </g>
        <path
          d="M1089.6 1310.53c-.1 0-.2-.02-.3-.05a.999.999 0 0 1-.65-1.26c3.45-10.83 4.38-21.57 2.79-31.91-.33-2.12-.77-4.24-1.31-6.32a.996.996 0 0 1 .72-1.22.996.996 0 0 1 1.22.72c.56 2.14 1.02 4.33 1.35 6.52 1.65 10.65.69 21.69-2.86 32.82-.14.43-.53.7-.96.7Z"
          className="cls-chr116"
        />
        <path
          d="M1116.32 1342.38h-50.77c-5.62 0-10.18-4.56-10.18-10.18v-2.81c0-11.75 9.52-21.27 21.27-21.27h28.6c11.75 0 21.27 9.52 21.27 21.27v2.81c0 5.62-4.56 10.18-10.18 10.18Z"
          className="cls-chr114"
        />
        <rect
          width={94.25}
          height={34.76}
          x={1047.49}
          y={1719.43}
          className="cls-chr111"
          rx={11.81}
          ry={11.81}
        />
        <rect
          width={94.25}
          height={34.76}
          x={1043.81}
          y={1325.25}
          className="cls-chr111"
          rx={11.81}
          ry={11.81}
        />
        <path
          d="m1133.89 1722.21-73.49 27.58c-5.86 2.2-12.11-1.66-13.96-8.61l-2.12-7.97c-1.85-6.95 1.4-14.37 7.25-16.57l73.49-27.58c5.86-2.2 12.11 1.66 13.96 8.61l2.12 7.97c1.85 6.95-1.4 14.37-7.25 16.57Z"
          className="cls-chr114"
        />
        <path
          d="m1133.93 1687.08-73.49 27.58c-5.86 2.2-12.11-1.66-13.96-8.61l-2.12-7.97c-1.85-6.95 1.4-14.37 7.25-16.57l73.49-27.58c5.86-2.2 12.11 1.66 13.96 8.61l2.12 7.97c1.85 6.95-1.4 14.37-7.25 16.57Z"
          className="cls-chr111"
        />
        <path
          d="m1133.89 1651.23-73.49 27.58c-5.86 2.2-12.11-1.66-13.96-8.61l-2.12-7.97c-1.85-6.95 1.4-14.37 7.25-16.57l73.49-27.58c5.86-2.2 12.11 1.66 13.96 8.61l2.12 7.97c1.85 6.95-1.4 14.37-7.25 16.57Z"
          className="cls-chr114"
        />
        <path
          d="m1133.85 1615.39-73.49 27.58c-5.86 2.2-12.11-1.66-13.96-8.61l-2.12-7.97c-1.85-6.95 1.4-14.37 7.25-16.57l73.49-27.58c5.86-2.2 12.11 1.66 13.96 8.61l2.12 7.97c1.85 6.95-1.4 14.37-7.25 16.57Z"
          className="cls-chr111"
        />
        <path
          d="m1133.82 1579.54-73.49 27.58c-5.86 2.2-12.11-1.66-13.96-8.61l-2.12-7.97c-1.85-6.95 1.4-14.37 7.25-16.57l73.49-27.58c5.86-2.2 12.11 1.66 13.96 8.61l2.12 7.97c1.85 6.95-1.4 14.37-7.25 16.57Z"
          className="cls-chr114"
        />
        <path
          d="m1133.78 1543.69-73.49 27.58c-5.86 2.2-12.11-1.66-13.96-8.61l-2.12-7.97c-1.85-6.95 1.4-14.37 7.25-16.57l73.49-27.58c5.86-2.2 12.11 1.66 13.96 8.61l2.12 7.97c1.85 6.95-1.4 14.37-7.25 16.57Z"
          className="cls-chr111"
        />
        <path
          d="m1133.74 1507.85-73.49 27.58c-5.86 2.2-12.11-1.66-13.96-8.61l-2.12-7.97c-1.85-6.95 1.4-14.37 7.25-16.57l73.49-27.58c5.86-2.2 12.11 1.66 13.96 8.61l2.12 7.97c1.85 6.95-1.4 14.37-7.25 16.57Z"
          className="cls-chr114"
        />
        <path
          d="m1133.7 1472-73.49 27.58c-5.86 2.2-12.11-1.66-13.96-8.61l-2.12-7.97c-1.85-6.95 1.4-14.37 7.25-16.57l73.49-27.58c5.86-2.2 12.11 1.66 13.96 8.61l2.12 7.97c1.85 6.95-1.4 14.37-7.25 16.57Z"
          className="cls-chr111"
        />
        <path
          d="m1133.66 1436.15-73.49 27.58c-5.86 2.2-12.11-1.66-13.96-8.61l-2.12-7.97c-1.85-6.95 1.4-14.37 7.25-16.57l73.49-27.58c5.86-2.2 12.11 1.66 13.96 8.61l2.12 7.97c1.85 6.95-1.4 14.37-7.25 16.57Z"
          className="cls-chr114"
        />
        <path
          d="m1133.63 1400.31-73.49 27.58c-5.86 2.2-12.11-1.66-13.96-8.61l-2.12-7.97c-1.85-6.95 1.4-14.37 7.25-16.57l73.49-27.58c5.86-2.2 12.11 1.66 13.96 8.61l2.12 7.97c1.85 6.95-1.4 14.37-7.25 16.57Z"
          className="cls-chr111"
        />
        <path
          d="m1133.59 1364.46-73.49 27.58c-5.86 2.2-12.11-1.66-13.96-8.61l-2.12-7.97c-1.85-6.95 1.4-14.37 7.25-16.57l73.49-27.58c5.86-2.2 12.11 1.66 13.96 8.61l2.12 7.97c1.85 6.95-1.4 14.37-7.25 16.57Z"
          className="cls-chr114"
        />
        <path
          d="M860.83 1391.03c4.6.44 19.17 1.41 29.93-4.92.28-.16 5.45-3.27 8.23-7.92 10.73-17.92-27.03-36.92-24.23-61.88.76-6.75 4.72-16.06 19.28-26.77-12.11 3.06-32.43 9.54-49.28 23.09-27.28 21.92-41.64 59.28-19.32 73.14 4.1 2.55 13.81 6.99 35.39 5.27Z"
          className="cls-chr110"
        />
        <path
          d="M859.9 1391.57c4.02.43 16.76 1.39 26.16-4.84.24-.16 4.76-3.22 7.2-7.8 9.38-17.64-23.63-36.35-21.17-60.92.66-6.64 4.12-15.81 16.85-26.36-10.59 3.02-28.35 9.39-43.08 22.73-23.84 21.58-36.4 58.36-16.89 72 3.58 2.51 12.07 6.88 30.93 5.19Z"
          className="cls-chr15"
        />
        <path
          d="M859.02 1388.77c2.57.19 9.45.42 15.83-2.93 3.4-1.78 5.73-4.09 6.87-5.73 6.16-8.89-7.3-19.97-13.45-36.69-2.31-6.28-4.55-15.97-2.37-29.01-3.47 1.94-9.58 5.68-15.46 11.48-19.12 18.85-27.28 51.09-10.13 59.75 3.16 1.6 8.72 3.42 18.72 3.14Z"
          className="cls-chr110"
        />
        <g className="cls-chr115">
          <path
            d="M859.95 1388.83c1.76.19 7.33.61 11.44-2.12.12-.08 2.08-1.41 3.15-3.41 3.4-6.34-5.1-13.89-10.23-24.53-1.94-4.02-4.06-9.85-4.55-17.5-2.64 2.44-6.27 6.19-9.5 11.21-5.82 9.05-13.7 27.46-3.85 34.08 1.75 1.18 5.54 2.98 13.53 2.27Z"
            className="cls-chr113"
          />
        </g>
        <path
          d="M860.75 1408.15c-.38 0-.74-.21-.92-.58-4.52-9.28-5.74-18.5-3.64-27.4.43-1.83 1.01-3.66 1.73-5.44.21-.53.81-.78 1.33-.57.53.21.78.81.57 1.33-.68 1.69-1.23 3.42-1.64 5.15-1.99 8.43-.82 17.18 3.49 26.03.25.51.04 1.12-.47 1.37-.14.07-.3.1-.45.1Z"
          className="cls-chr116"
        />
        <path
          d="M823.33 1434.25h71.49c5.06 0 9.16-4.1 9.16-9.16 0-10.56-8.56-19.12-19.12-19.12H833.3c-10.56 0-19.12 8.56-19.12 19.12 0 5.06 4.1 9.16 9.16 9.16Z"
          className="cls-chr12"
        />
        <rect
          width={118.99}
          height={28.69}
          x={794.92}
          y={1745.45}
          className="cls-chr16"
          rx={12.05}
          ry={12.05}
        />
        <rect
          width={118.99}
          height={28.69}
          x={799.58}
          y={1420.11}
          className="cls-chr16"
          rx={12.05}
          ry={12.05}
        />
        <path
          d="m804.84 1747.75 92.77 22.76c7.4 1.81 15.29-1.37 17.62-7.11l2.68-6.58c2.34-5.74-1.76-11.86-9.16-13.68l-92.77-22.76c-7.4-1.81-15.29 1.37-17.62 7.11l-2.68 6.58c-2.34 5.74 1.76 11.86 9.16 13.68Z"
          className="cls-chr12"
        />
        <path
          d="m804.79 1718.75 92.77 22.76c7.4 1.81 15.29-1.37 17.62-7.11l2.68-6.58c2.34-5.74-1.76-11.86-9.16-13.68l-92.77-22.76c-7.4-1.81-15.29 1.37-17.62 7.11l-2.68 6.58c-2.34 5.74 1.76 11.86 9.16 13.68Z"
          className="cls-chr16"
        />
        <path
          d="m804.84 1689.16 92.77 22.76c7.4 1.81 15.29-1.37 17.62-7.11l2.68-6.58c2.34-5.74-1.76-11.86-9.16-13.68l-92.77-22.76c-7.4-1.81-15.29 1.37-17.62 7.11l-2.68 6.58c-2.34 5.74 1.76 11.86 9.16 13.68Z"
          className="cls-chr12"
        />
        <path
          d="m804.89 1659.58 92.77 22.76c7.4 1.81 15.29-1.37 17.62-7.11l2.68-6.58c2.34-5.74-1.76-11.86-9.16-13.68l-92.77-22.76c-7.4-1.81-15.29 1.37-17.62 7.11l-2.68 6.58c-2.34 5.74 1.76 11.86 9.16 13.68Z"
          className="cls-chr16"
        />
        <path
          d="m804.93 1629.99 92.77 22.76c7.4 1.81 15.29-1.37 17.62-7.11l2.68-6.58c2.34-5.74-1.76-11.86-9.16-13.68l-92.77-22.76c-7.4-1.81-15.29 1.37-17.62 7.11l-2.68 6.58c-2.34 5.74 1.76 11.86 9.16 13.68Z"
          className="cls-chr12"
        />
        <path
          d="m804.98 1600.41 92.77 22.76c7.4 1.81 15.29-1.37 17.62-7.11l2.68-6.58c2.34-5.74-1.76-11.86-9.16-13.68l-92.77-22.76c-7.4-1.81-15.29 1.37-17.62 7.11l-2.68 6.58c-2.34 5.74 1.76 11.86 9.16 13.68Z"
          className="cls-chr16"
        />
        <path
          d="m805.03 1570.82 92.77 22.76c7.4 1.81 15.29-1.37 17.62-7.11l2.68-6.58c2.34-5.74-1.76-11.86-9.16-13.68l-92.77-22.76c-7.4-1.81-15.29 1.37-17.62 7.11l-2.68 6.58c-2.34 5.74 1.76 11.86 9.16 13.68Z"
          className="cls-chr12"
        />
        <path
          d="m805.08 1541.23 92.77 22.76c7.4 1.81 15.29-1.37 17.62-7.11l2.68-6.58c2.34-5.74-1.76-11.86-9.16-13.68l-92.77-22.76c-7.4-1.81-15.29 1.37-17.62 7.11l-2.68 6.58c-2.34 5.74 1.76 11.86 9.16 13.68Z"
          className="cls-chr16"
        />
        <path
          d="m805.13 1511.65 92.77 22.76c7.4 1.81 15.29-1.37 17.62-7.11l2.68-6.58c2.34-5.74-1.76-11.86-9.16-13.68l-92.77-22.76c-7.4-1.81-15.29 1.37-17.62 7.11l-2.68 6.58c-2.34 5.74 1.76 11.86 9.16 13.68Z"
          className="cls-chr12"
        />
        <path
          d="m805.17 1482.06 92.77 22.76c7.4 1.81 15.29-1.37 17.62-7.11l2.68-6.58c2.34-5.74-1.76-11.86-9.16-13.68l-92.77-22.76c-7.4-1.81-15.29 1.37-17.62 7.11l-2.68 6.58c-2.34 5.74 1.76 11.86 9.16 13.68Z"
          className="cls-chr16"
        />
        <path
          d="m805.22 1452.47 92.77 22.76c7.4 1.81 15.29-1.37 17.62-7.11l2.68-6.58c2.34-5.74-1.76-11.86-9.16-13.68l-92.77-22.76c-7.4-1.81-15.29 1.37-17.62 7.11l-2.68 6.58c-2.34 5.74 1.76 11.86 9.16 13.68Z"
          className="cls-chr12"
        />
        <path
          d="M1045.89 1759.8c34.75 9.11 116.47 35.91 175.46 113.4 19.75 25.94 32.53 51.75 40.95 73.71-5.23-3.91-11.04-7.88-17.45-11.75-13.24-8.01-25.9-13.7-37.03-17.8 1.29 6.83 2.33 15.83 1.78 26.35-.59 11.3-2.84 20.71-5.04 27.63-35.55-40.8-82.95-86.94-144.52-129.83a783.402 783.402 0 0 0-75.14-46.29c20.33-11.8 40.66-23.61 60.98-35.41Z"
          className="cls-chr13"
        />
        <path
          d="M1262.3 1946.91c-8.43-21.96-21.2-47.77-40.95-73.71-58.99-77.48-140.71-104.29-175.46-113.4-20.33 11.8-40.66 23.61-60.98 35.41 17.55 9.5 35.82 20.25 54.54 32.43 16.02-4.12 55.61-11.98 101.2 3.89 61.57 21.44 90.13 70.86 96.86 83.33a147.01 147.01 0 0 0-16.13-8.33 147.765 147.765 0 0 0-36.33-10.66c4.73 8.59 12.7 26.3 9.5 47.72-.71 4.77-1.89 9.08-3.25 12.88 4.6 5.02 9.03 9.99 13.29 14.87 2.2-6.92 4.44-16.33 5.04-27.63.55-10.52-.49-19.52-1.78-26.35 11.13 4.1 23.79 9.8 37.03 17.8 6.41 3.87 12.22 7.84 17.45 11.75Z"
          className="cls-chr17"
        />
        <path
          d="M895.91 1471.19h172.37v289.08H895.91z"
          className="cls-chr117"
        />
        <path
          d="M1068.13 1471.19H895.76v56.61c.05 14.93.11 29.87.16 44.8 4.76 7.99 8.88 9.94 11.95 10.02 8.55.22 10.51-14.06 23.59-19.14 8.94-3.47 11.55 1.82 25.39.65 19.52-1.65 20.81-12.71 33.86-11.72 16.59 1.26 20.67 19.61 37.78 19.42 9.86-.11 13.48-6.26 16.91-5.09 8.39 2.86 5.52 46.13-30.74 193.53h53.47v-289.08Z"
          style={{
            fill: "#db7b33",
          }}
        />
        <path
          d="M1075.45 1482.52c.64 6.69-3.76 10.08-2.39 21.39 1.97 16.14 12.58 22.86 9.12 29.3-2.7 5-12.31 6.85-17.58 3.58-6.04-3.75-3.82-12.65-7.81-14-6.04-2.03-11.69 18.17-26.04 21.81-12.67 3.21-17.18-10.26-35.76-12.11-20.54-2.06-25.36 13.29-44.31 11.32-21.8-2.27-32.14-25.04-39.73-21.01-8.78 4.66 4.48 35.44-7.16 42.97-5.08 3.29-13.87 1.49-17.9-3.26-6.37-7.49 2.2-18.76 4.23-40.37 2.35-24.9-7.46-26.49-3.15-39.62 9.01-27.42 58.13-39.81 94.81-39.83 43.88-.02 91.69 18.97 93.68 39.83Z"
          className="cls-chr19"
        />
        <path
          d="M1055.43 1474.48c-.65 11.4-40.18 18.98-67.94 19.63-34.17.81-77.4-8.26-77.96-20.22-.54-11.47 38.1-25.83 73.24-25.68 35.21.15 73.31 14.9 72.66 26.27Z"
          style={{
            fill: "#ffaa71",
          }}
        />
        <path
          d="M999.94 1470.39c.11.71-6.65 2.85-14.65 3.42-8.47.6-18.67-.55-18.8-2.44-.15-2.18 13.01-5.19 13.43-4.15.19.47-2.31 1.41-2.15 2.27.46 2.46 21.98-.34 22.17.9Z"
          className="cls-chr117"
        />
        <path
          d="M980.55 1452.18c-3.78.46-15.77 1.5-24.62-5.21-.23-.17-4.48-3.47-6.78-8.4-8.83-19 22.24-39.15 19.93-65.61-.62-7.15-3.88-17.03-15.86-28.39 9.97 3.25 26.68 10.12 40.55 24.48 22.44 23.24 34.26 62.85 15.9 77.55-3.37 2.7-11.36 7.41-29.12 5.59Z"
          className="cls-chr110"
        />
        <path
          d="M981.31 1452.75c-3.31.45-13.79 1.48-21.52-5.13-.2-.17-3.92-3.41-5.92-8.27-7.72-18.71 19.44-38.54 17.42-64.59-.55-7.04-3.39-16.76-13.87-27.95 8.71 3.2 23.32 9.96 35.44 24.1 19.62 22.88 29.95 61.87 13.9 76.34-2.95 2.66-9.93 7.3-25.45 5.5Z"
          className="cls-chr15"
        />
        <path
          d="M982.03 1449.78c-2.12.2-7.77.44-13.03-3.11-2.8-1.89-4.71-4.33-5.65-6.08-5.07-9.42 6.01-21.17 11.07-38.9 1.9-6.66 3.74-16.93 1.95-30.76a63.29 63.29 0 0 1 12.72 12.17c15.73 19.98 22.45 54.17 8.34 63.35-2.6 1.69-7.18 3.63-15.4 3.33Z"
          className="cls-chr110"
        />
        <g className="cls-chr115">
          <path
            d="M981.27 1449.84c-1.45.2-6.03.65-9.41-2.25-.1-.08-1.71-1.5-2.59-3.62-2.8-6.72 4.2-14.73 8.42-26 1.6-4.26 3.34-10.45 3.74-18.56a59.99 59.99 0 0 1 7.81 11.88c4.79 9.59 11.27 29.12 3.17 36.13-1.44 1.25-4.56 3.16-11.13 2.41Z"
            className="cls-chr113"
          />
        </g>
        <path
          d="M1045.64 1476.08c.38.89-14.01 10.17-33.21 13.67-14.78 2.7-27.79 1.13-27.83.24-.04-.86 12.09-.79 30.52-4.88 19.45-4.32 30.2-9.79 30.52-9.03Z"
          className="cls-chr112"
        />
        <ellipse
          cx={892.31}
          cy={1553.99}
          className="cls-chr112"
          rx={5.37}
          ry={7.2}
        />
        <ellipse
          cx={1072.51}
          cy={1528.82}
          className="cls-chr112"
          rx={5.6}
          ry={4.85}
        />
        <path
          d="M980.61 1470.2c-.11 0-.23-.02-.34-.06a.967.967 0 0 1-.56-1.23c3.57-9.44 4.54-18.8 2.88-27.81-.34-1.85-.8-3.7-1.36-5.5-.16-.5.13-1.04.63-1.2.5-.16 1.04.13 1.2.63.58 1.88 1.06 3.8 1.41 5.73 1.72 9.36.72 19.06-2.98 28.83-.15.38-.51.62-.89.62Z"
          className="cls-chr116"
        />
        <path
          d="M1066.23 1477.22c1.98.98 2.5 4.77 1.95 7.49-2.2 10.86-23.69 15.09-33.78 17.07-20.29 3.99-38.72 2.27-38.82.51-.15-2.58 39.54.92 58.92-17.9 2.26-2.2 8.45-8.78 11.72-7.16Z"
          className="cls-chr117"
        />
        <path
          d="M1016.51 1813.03a567.64 567.64 0 0 0 85.06 9.71c81.95 3.11 123.13 4.68 144.13-28.18 25.64-40.12 14.37-120.85-20.99-146.32-14.17-10.21-30.84-10.54-66.63-.66-37.94 10.47-92.88 31.18-155.71 75.93-2.26 8.73-6.35 28.73-1.26 52.75 3.73 17.63 10.84 30 15.4 36.77Z"
          className="cls-chr13"
        />
        <path
          d="M1158.08 1647.58c35.79-9.88 52.46-9.54 66.63.66 35.36 25.46 46.63 106.2 20.99 146.32-21 32.86-62.18 31.29-144.13 28.18a567.64 567.64 0 0 1-85.06-9.71c-1.9-2.81-4.23-6.61-6.58-11.33 1.23-.84 2.52-1.46 3.84-1.81 2.07-.56 3.71-.28 4.01-.25 143.29 17.1 179.58-36.38 179.58-36.38 15.91-23.46 18.18-62.03 5.31-79.05-9.43-12.47-26.81-13.14-61.49-4.81-33.62 8.08-83.18 24.53-141.92 61.67.76-7.64 2.12-13.7 3.12-17.56 62.83-44.75 117.77-65.46 155.71-75.93Z"
          className="cls-chr17"
        />
        <path
          d="M944.71 1813.03a567.64 567.64 0 0 1-85.06 9.71c-81.95 3.11-123.13 4.68-144.13-28.18-25.64-40.12-14.37-120.85 20.99-146.32 14.17-10.21 30.84-10.54 66.63-.66 37.94 10.47 92.88 31.18 155.71 75.93 2.26 8.73 6.35 28.73 1.26 52.75-3.73 17.63-10.84 30-15.4 36.77Z"
          className="cls-chr13"
        />
        <path
          d="M803.14 1647.58c-35.79-9.88-52.46-9.54-66.63.66-35.36 25.46-46.63 106.2-20.99 146.32 21 32.86 62.18 31.29 144.13 28.18a567.64 567.64 0 0 0 85.06-9.71c1.9-2.81 4.23-6.61 6.58-11.33-1.23-.84-2.52-1.46-3.84-1.81-2.07-.56-3.71-.28-4.01-.25-143.29 17.1-179.58-36.38-179.58-36.38-15.91-23.46-18.18-62.03-5.31-79.05 9.43-12.47 26.81-13.14 61.49-4.81 33.62 8.08 83.18 24.53 141.92 61.67-.76-7.64-2.12-13.7-3.12-17.56-62.83-44.75-117.77-65.46-155.71-75.93Z"
          className="cls-chr17"
        />
        <path
          d="M1018.12 1810.22c2.92 10.27-5.69 20.18-16.27 18.75-6.38-.87-13.43-1.37-21.02-1.23-10.82.19-20.4 1.63-28.45 3.48-7.65 1.75-15.36-2.81-17.53-10.35-4.63-16.1-8.74-37.59-8.15-62.92.46-19.78 3.67-36.93 7.46-50.7 2.28-8.3 11.16-12.91 19.26-10.02a89.04 89.04 0 0 0 28.83 5.18c6.45.08 12.39-.56 17.75-1.59 10.72-2.06 19.98 7.72 17.22 18.28-4.15 15.91-7.04 35.95-5.06 58.8 1.04 12.03 3.26 22.87 5.95 32.33Z"
          className="cls-chr13"
        />
        <path
          d="M1002.8 1808.12c-15.48.86-24.79-29.07-34.9-27.06-9.5 1.89-9.05 29.91-15.31 30.27-4.28.24-9.2-12.6-11.75-25.28-7.08-35.17 2.78-74.98 13.53-75.49 10.52-.5 15.18 37.19 28.13 36.68 13.25-.52 20.63-38.39 28.13-37.03 3.3.59 4.64 8.41 5.27 14.36.43-1.87.87-3.7 1.33-5.47 2.75-10.56-6.51-20.35-17.22-18.28a88.888 88.888 0 0 1-17.75 1.59c-11.43-.13-21.2-2.46-28.83-5.18-8.1-2.89-16.98 1.73-19.26 10.02a209.897 209.897 0 0 0-7.46 50.7c-.59 25.33 3.52 46.82 8.15 62.92 2.17 7.54 9.88 12.1 17.53 10.35a138.139 138.139 0 0 1 49.47-2.25c10.58 1.43 19.19-8.48 16.27-18.75-.92-3.22-1.77-6.61-2.55-10.13-2.7 3.38-7.09 7.72-12.77 8.03Z"
          className="cls-chr17"
        />
        <path
          d="M1009.45 1763.25c-1.37 24.7-.34 36.76-4.75 37.98-4.51 1.25-10.01-10.18-30.29-24.94-4.32-3.15-7.52-5.14-10.78-4.26-8.7 2.35-8.47 22.58-10.68 22.55-4.14-.05-9.82-70.5-.71-72.17 7.16-1.31 15.02 41.45 29.67 41.31 15.05-.15 24.57-45.46 29.44-44.16 2.75.73-.32 15.14-1.9 43.68ZM1192.78 1738.42c-16.45 47.47-91.66 57.43-92.58 55.19-.76-1.86 50.51-10.38 73-52.17 15.13-28.11 9.55-57.02 13.53-57.15 3.98-.13 14.93 28.52 6.05 54.13ZM764.44 1738.42c16.45 47.47 91.66 57.43 92.58 55.19.76-1.86-50.51-10.38-73-52.17-15.13-28.11-9.55-57.02-13.53-57.15-3.98-.13-14.93 28.52-6.05 54.13Z"
          className="cls-chr11"
        />
        <path
          d="m1319.6 1315.69 9.41 19.07c.54 1.1 1.59 1.86 2.8 2.04l21.04 3.06c3.05.44 4.27 4.19 2.06 6.35l-15.23 14.84c-.88.86-1.28 2.09-1.07 3.29l3.59 20.96c.52 3.04-2.67 5.36-5.4 3.92l-18.82-9.89a3.714 3.714 0 0 0-3.46 0l-18.82 9.89c-2.73 1.44-5.92-.88-5.4-3.92l3.59-20.96a3.69 3.69 0 0 0-1.07-3.29l-15.23-14.84c-2.21-2.15-.99-5.9 2.06-6.35l21.04-3.06c1.21-.18 2.26-.94 2.8-2.04l9.41-19.07c1.37-2.77 5.31-2.77 6.67 0ZM589.38 1607.73l6.28 12.72c.36.73 1.06 1.24 1.87 1.36l14.04 2.04c2.04.3 2.85 2.8 1.38 4.23l-10.16 9.9c-.59.57-.85 1.39-.71 2.2l2.4 13.98c.35 2.03-1.78 3.57-3.6 2.62l-12.55-6.6c-.72-.38-1.59-.38-2.31 0l-12.55 6.6c-1.82.96-3.95-.59-3.6-2.62l2.4-13.98a2.49 2.49 0 0 0-.71-2.2l-10.16-9.9c-1.47-1.44-.66-3.94 1.38-4.23l14.04-2.04c.81-.12 1.51-.63 1.87-1.36l6.28-12.72c.91-1.85 3.54-1.85 4.45 0ZM632.88 1288.11l12.82 25.97c.74 1.5 2.17 2.53 3.82 2.77l28.66 4.17c4.16.6 5.82 5.71 2.81 8.65l-20.74 20.22a5.086 5.086 0 0 0-1.46 4.49l4.9 28.55c.71 4.14-3.64 7.3-7.36 5.34l-25.64-13.48a5.053 5.053 0 0 0-4.72 0l-25.64 13.48c-3.72 1.96-8.07-1.2-7.36-5.34l4.9-28.55c.28-1.64-.26-3.32-1.46-4.49l-20.74-20.22c-3.01-2.93-1.35-8.04 2.81-8.65l28.66-4.17a5.09 5.09 0 0 0 3.82-2.77l12.82-25.97c1.86-3.77 7.23-3.77 9.09 0ZM1333.5 1591.97l8.92 18.08a3.536 3.536 0 0 0 2.66 1.93l19.95 2.9c2.89.42 4.05 3.98 1.96 6.02l-14.44 14.07c-.83.81-1.21 1.98-1.01 3.12l3.41 19.87c.49 2.88-2.53 5.08-5.12 3.72l-17.84-9.38a3.523 3.523 0 0 0-3.28 0l-17.84 9.38c-2.59 1.36-5.61-.84-5.12-3.72l3.41-19.87c.2-1.14-.18-2.31-1.01-3.12l-14.44-14.07c-2.09-2.04-.94-5.6 1.96-6.02l19.95-2.9c1.15-.17 2.14-.89 2.66-1.93l8.92-18.08c1.29-2.62 5.03-2.62 6.33 0ZM1221.79 1482.84l5.59 11.34c.32.65.95 1.11 1.67 1.21l12.51 1.82c1.81.26 2.54 2.49 1.23 3.77l-9.05 8.82a2.23 2.23 0 0 0-.64 1.96l2.14 12.46c.31 1.81-1.59 3.19-3.21 2.33l-11.19-5.88c-.64-.34-1.41-.34-2.06 0l-11.19 5.88c-1.62.85-3.52-.52-3.21-2.33l2.14-12.46c.12-.72-.11-1.45-.64-1.96l-9.05-8.82c-1.31-1.28-.59-3.51 1.23-3.77l12.51-1.82c.72-.1 1.34-.56 1.67-1.21l5.59-11.34c.81-1.64 3.16-1.64 3.97 0Z"
          className="cls-chr117"
        />
        <path
          d="m1383.74 1455.35 4.48 9.08c.26.52.76.89 1.34.97l10.02 1.46c1.45.21 2.03 2 .98 3.02l-7.25 7.07c-.42.41-.61.99-.51 1.57l1.71 9.98c.25 1.45-1.27 2.55-2.57 1.87l-8.97-4.71c-.52-.27-1.13-.27-1.65 0l-8.97 4.71c-1.3.68-2.82-.42-2.57-1.87l1.71-9.98c.1-.58-.09-1.16-.51-1.57l-7.25-7.07c-1.05-1.03-.47-2.81.98-3.02l10.02-1.46c.58-.08 1.08-.45 1.34-.97l4.48-9.08c.65-1.32 2.53-1.32 3.18 0ZM456.42 1559.63l4.48 9.08c.26.52.76.89 1.34.97l10.02 1.46c1.45.21 2.03 2 .98 3.02l-7.25 7.07c-.42.41-.61.99-.51 1.57l1.71 9.98c.25 1.45-1.27 2.55-2.57 1.87l-8.97-4.71c-.52-.27-1.13-.27-1.65 0l-8.97 4.71c-1.3.68-2.82-.42-2.57-1.87l1.71-9.98c.1-.58-.09-1.16-.51-1.57l-7.25-7.07c-1.05-1.03-.47-2.81.98-3.02l10.02-1.46c.58-.08 1.08-.45 1.34-.97l4.48-9.08c.65-1.32 2.53-1.32 3.18 0ZM604.75 1476.05l3.7 7.5c.21.43.63.73 1.1.8l8.28 1.2c1.2.17 1.68 1.65.81 2.5l-5.99 5.84c-.35.34-.5.82-.42 1.3l1.41 8.25c.21 1.2-1.05 2.11-2.13 1.54l-7.41-3.89c-.43-.22-.94-.22-1.36 0l-7.41 3.89c-1.07.56-2.33-.35-2.13-1.54l1.41-8.25c.08-.48-.08-.96-.42-1.3l-5.99-5.84c-.87-.85-.39-2.32.81-2.5l8.28-1.2c.48-.07.89-.37 1.1-.8l3.7-7.5c.54-1.09 2.09-1.09 2.63 0ZM456.15 1371.75l3.7 7.5c.21.43.63.73 1.1.8l8.28 1.2c1.2.17 1.68 1.65.81 2.5l-5.99 5.84c-.35.34-.5.82-.42 1.3l1.41 8.25c.21 1.2-1.05 2.11-2.13 1.54l-7.41-3.89c-.43-.22-.94-.22-1.36 0l-7.41 3.89c-1.07.56-2.33-.35-2.13-1.54l1.41-8.25c.08-.48-.08-.96-.42-1.3l-5.99-5.84c-.87-.85-.39-2.32.81-2.5l8.28-1.2c.48-.07.89-.37 1.1-.8l3.7-7.5c.54-1.09 2.09-1.09 2.63 0ZM1485.59 1575.85l3.7 7.5c.21.43.63.73 1.1.8l8.28 1.2c1.2.17 1.68 1.65.81 2.5l-5.99 5.84c-.35.34-.5.82-.42 1.3l1.41 8.25c.21 1.2-1.05 2.11-2.13 1.54l-7.41-3.89c-.43-.22-.94-.22-1.36 0l-7.41 3.89c-1.07.56-2.33-.35-2.13-1.54l1.41-8.25c.08-.48-.08-.96-.42-1.3l-5.99-5.84c-.87-.85-.39-2.32.81-2.5l8.28-1.2c.48-.07.89-.37 1.1-.8l3.7-7.5c.54-1.09 2.09-1.09 2.63 0ZM1527.03 1363.31l5.91 11.98c.34.69 1 1.17 1.76 1.28l13.22 1.92c1.92.28 2.68 2.64 1.3 3.99l-9.57 9.32c-.55.54-.8 1.31-.67 2.07l2.26 13.17c.33 1.91-1.68 3.37-3.39 2.47l-11.82-6.22c-.68-.36-1.5-.36-2.18 0l-11.82 6.22c-1.72.9-3.72-.55-3.39-2.47l2.26-13.17c.13-.76-.12-1.53-.67-2.07l-9.57-9.32c-1.39-1.35-.62-3.71 1.3-3.99l13.22-1.92c.76-.11 1.42-.59 1.76-1.28l5.91-11.98c.86-1.74 3.34-1.74 4.19 0Z"
          className="cls-chr19"
        />
        <path
          d="m739.4 1507.45 5.59 11.34c.32.65.95 1.11 1.67 1.21l12.51 1.82c1.81.26 2.54 2.49 1.23 3.77l-9.05 8.82a2.23 2.23 0 0 0-.64 1.96l2.14 12.46c.31 1.81-1.59 3.19-3.21 2.33l-11.19-5.88c-.64-.34-1.41-.34-2.06 0l-11.19 5.88c-1.62.85-3.52-.52-3.21-2.33l2.14-12.46c.12-.72-.11-1.45-.64-1.96l-9.05-8.82c-1.31-1.28-.59-3.51 1.23-3.77l12.51-1.82c.72-.1 1.34-.56 1.67-1.21l5.59-11.34c.81-1.64 3.16-1.64 3.97 0Z"
          className="cls-chr117"
        />
        {children}
      </g>
    </svg>
  );
}
